import { render, staticRenderFns } from "./TimelineBody.vue?vue&type=template&id=2a0ff416&scoped=true"
import script from "./TimelineBody.vue?vue&type=script&lang=ts"
export * from "./TimelineBody.vue?vue&type=script&lang=ts"
import style0 from "./TimelineBody.vue?vue&type=style&index=0&id=2a0ff416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ff416",
  null
  
)

export default component.exports